// extracted by mini-css-extract-plugin
module.exports = {"frameWrap":"iframe-modal_frameWrap__NbYrQ","frame":"iframe-modal_frame__5Cvdx","overlay":"iframe-modal_overlay__N1Ve5"};